<app-nav-header></app-nav-header>
<div class="wrapper">
	<div class="main">
		<div id="homePage">
			<div class="aboutKYArea">
				<div class="bannerArea">
					<!-- <div class="animationBox">
						<img
							class="animationLogo"
							src="/assets/images/indexPage/hero-animation-logo.webp"
							alt=""
						/>
					</div> -->
					<div class="banner">
						<div class="titleBox">
							<div class="text-center">
								<em>歡迎來到 Big Aunt's，一起享受拆卡的樂趣！！</em>
								<br />
								<em>Big Aunt's｜Break. Collect. Enjoy.</em>
								<!-- <em>
									每一次開團，都是阿姨的誠意與熱情，歡迎您一起加入大阿姨的團拆世界和我們一起狂抽猛送！
								</em> -->
								<br />
							</div>
							<div class="carouselBox">
								<div class="swipeBox">
									<div class="swiper-interact">
										<div class="ctr">
											<div class="slide-idx">
												<!-- <span>0{{ carouselPageRef }}</span> -->
												<!-- <span class="post-fix">/25</span> -->
											</div>
											<div class="scroll">
												<div class="swiper-scrollbar-hero"></div>
											</div>
											<div class="action">
												<button
													class="swiper-button-prev"
													aria-label="前一頁"
												></button>
												<button
													class="swiper-button-next"
													aria-label="下一頁"
												></button>
											</div>
										</div>
									</div>
									<ng-container *ngIf="showSwiper">
										<swiper
											#heroSwiper
											[slidesPerView]="slidesPerView"
											[speed]="500"
											[spaceBetween]="35"
											[scrollbar]="{ el: '.swiper-scrollbar-hero' }"
											[navigation]="{
												nextEl: '.swiper-button-next',
												prevEl: '.swiper-button-prev'
											}"
											[autoplay]="{ delay: 5000, disableOnInteraction: false }"
											[centeredSlides]="true"
										>
											<ng-container *ngFor="let news of this.highlightNews">
												<ng-template swiperSlide>
													<div class="info-card">
														<div class="slide-info">
															<time>{{ news.Date }}</time>
															<h2>{{ news.Content }}</h2>
															<span>Big Aunt's Big Hits !!</span>
														</div>
														<div class="imgBox">
															<img
																[src]="news.Image"
																alt=""
															/>
														</div>
													</div>
												</ng-template>
											</ng-container>
										</swiper>
									</ng-container>
								</div>
							</div>
							<!-- <div style="text-align: center; margin-top: 6rem">
								<img
									src="/bigaunt/assets/images/big-aunt-logo.png"
									alt="Big Aunt's"
									style="width: 20vh; height: 20vh"
								/>
							</div> -->
							<!-- <br />
							<em style="margin-left: 3rem">球鞋時事｜球員卡團拆</em> -->
						</div>
						<!-- <div class="carouselBox">
							<div class="swipeBox">
								<div class="swiper-interact">
									<div class="ctr">
										<div class="slide-idx">
											<span>0{{ carouselPageRef }}</span>
											<span class="post-fix">/05</span>
										</div>
										<div class="scroll">
											<div class="swiper-scrollbar-hero"></div>
										</div>
										<div class="action">
											<button
												class="swiper-button-prev"
												aria-label="前一頁"
											></button>
											<button
												class="swiper-button-next"
												aria-label="下一頁"
											></button>
										</div>
									</div>
								</div>
								<ng-container *ngIf="showSwiper">
									<swiper
										#heroSwiper
										[slidesPerView]="slidesPerView"
										[speed]="500"
										[spaceBetween]="35"
										[scrollbar]="{ el: '.swiper-scrollbar-hero' }"
										[navigation]="{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }"
										[autoplay]="{ delay: 5000, disableOnInteraction: false }"
										[centeredSlides]="true"
									>
										<ng-container *ngFor="let news of this.highlightNews">
											<ng-template swiperSlide>
												<div class="info-card">
													<div class="slide-info">
														<time>{{ news.Date }}</time>
														<h2>{{ news.Content }}</h2>
														<div class="tagsBox">
															<p
																class="tag"
																*ngFor="let tag of news.Tags"
															>
																{{ tag }}
															</p>
														</div>
														<a
															[href]="goViewNews(news.TypeEN, news.FileTitle)"
															[title]="'前往' + news.Content"
														>
															深入瞭解 &nbsp;
															<i
																class="fa fa-arrow-right"
																aria-hidden="true"
															></i>
														</a>
													</div>
													<div class="imgBox">
														<img
															[src]="news.Image"
															alt=""
														/>
													</div>
												</div>
											</ng-template>
										</ng-container>
									</swiper>
								</ng-container>
							</div>
						</div> -->
					</div>
				</div>
			</div>

			<!-- <app-statistics></app-statistics> -->

			<!-- <div class="securityArea">
				<div class="securityBox securityBoxTab">
					<div class="pyramid">
						<img
							#pyramidPic
							src="/assets/images/indexPage/pyramid-1024-nation.webp"
							alt=""
						/>
					</div>
					<div class="narrative">
						<h2>{{ securityTitle }}</h2>
						<p-tabView
							(onChange)="onTabChange($event)"
							[(activeIndex)]="tabIdx"
						>
							<p-tabPanel header="國安">
								<ng-container *ngTemplateOutlet="nationTpl"></ng-container>
							</p-tabPanel>
							<p-tabPanel header="資安">
								<ng-container *ngTemplateOutlet="infoTpl"></ng-container>
							</p-tabPanel>
							<p-tabPanel header="治安">
								<ng-container *ngTemplateOutlet="orderTpl"></ng-container>
							</p-tabPanel>
						</p-tabView>
					</div>
				</div>

				<div class="securityBox securityBoxSwiper">
					<swiper
						#securitySwiper
						[slidesPerView]="1"
						[speed]="500"
						[spaceBetween]="140"
						[navigation]="{
							nextEl: '.swiper-button-next-security',
							prevEl: '.swiper-button-prev-security'
						}"
					>
						<ng-template swiperSlide>
							<div class="info-card-security">
								<h2>安全科技的三大願景</h2>
								<div class="pyramid">
									<img
										#pyramidPic
										src="/assets/images/indexPage/pyramid-1024-nation.webp"
										alt="國安：構築精實的國防科技"
									/>
								</div>

								<div class="narrative">
									<ng-container *ngTemplateOutlet="nationTpl"></ng-container>
								</div>
							</div>
						</ng-template>
						<ng-template swiperSlide>
							<div class="info-card-security">
								<h2>安全科技的三大願景</h2>
								<div class="pyramid">
									<img
										#pyramidPic
										src="/assets/images/indexPage/pyramid-1024-info.webp"
										alt="資安：建構堅實的安全基石"
									/>
								</div>

								<div class="narrative">
									<ng-container *ngTemplateOutlet="infoTpl"></ng-container>
								</div>
							</div>
						</ng-template>
						<ng-template swiperSlide>
							<div class="info-card-security">
								<h2>安全科技的三大願景</h2>
								<div class="pyramid">
									<img
										#pyramidPic
										src="/assets/images/indexPage/pyramid-1024-order.webp"
										alt="治安：打造高效的治安管理"
									/>
								</div>

								<div class="narrative">
									<ng-container *ngTemplateOutlet="orderTpl"></ng-container>
								</div>
							</div>
						</ng-template>
					</swiper>

					<button
						class="swiper-button-prev-security"
						aria-label="前一頁"
					>
						<img
							src="/assets/images//indexPage/security-swiper-left-btn.svg"
							alt="上一頁按鈕"
						/>
					</button>
					<button
						class="swiper-button-next-security"
						aria-label="下一頁"
					>
						<img
							src="/assets/images//indexPage/security-swiper-right-btn.svg"
							alt="下一頁按鈕"
						/>
					</button>
				</div>
			</div> -->

			<!-- <div class="coreTechArea">
				<div class="coreTechBox">
					<div class="desc">
						<span>核心技術</span>
						<h2>提供前瞻性技術</h2>
					</div>

					<div class="coreStackBox">
						<div class="bigDataBox">
							<h3 class="">Big Data</h3>
							<p>
								透過蒐集、處理和分析巨量數據，從中挖掘出有價值的訊息和情報，以協助重要決策與關鍵業務流程優化，包括情報分析、虛實整合、目標黑名單、關鍵知識庫等。
							</p>
						</div>
						<div class="iotBox">
							<h3 class="">IoT</h3>
							<p>
								通過連接和整合各種智慧設備，蒐集和分析大量的數據，以完成自動化控制和智慧決策。其中結合了融合了大數據、雲端計算、人工智慧等前瞻技術，能夠處理來自不同來源的大量數據，提供即時監控與分析，包括智慧監控平台、智慧監控裝置等。
							</p>
						</div>
						<div class="aiBox">
							<h3 class="">AI</h3>
							<p>
								運用機器學習、深度學習和數據挖掘等先進技術，能夠處理和分析海量數據，提供高準確性和高效能的智慧解決方案，以達到關鍵情報的解讀與數據的探勘，如生物特徵識別、語音識別、圖像識別、自然語言處理等。
							</p>
						</div>
						<div class="infoSecBox">
							<h3 class="">InfoSec</h3>
							<p>
								通過模擬網路攻擊手段和防禦管理措施，保護資訊系統和數據的機密性、完整性和可用性，有效應對各種網絡威脅和攻擊，保障數據和系統的安全，如資安通報、社交工程演練等。
							</p>
						</div>
					</div>
				</div>
			</div> -->

			<!-- <div class="solutionArea">
				<div class="solutionBox">
					<div class="narrativeBox">
						<div class="narrativeNestedBox">
							<span>實現需求</span>
							<h2>締造獨特價值的解決方案</h2>
							<p>憑藉前瞻科技的力量，提供客製化解決方案，以創新與專業，引領科技未來，贏得客戶信賴。</p>

							<button
								class="view-btn"
								(click)="router.navigateByUrl('solutions')"
							>
								<span>檢視所有解決方案</span>
								<i
									class="fa fa-arrow-right"
									aria-hidden="true"
								></i>
							</button>
						</div>
					</div>
					<div class="solutionSwiperBox">
						<div class="swiper-pagination-solution"></div>
						<swiper
							[speed]="500"
							[loop]="true"
							[centeredSlides]="true"
							[observeParents]="true"
							[pagination]="{ el: '.swiper-pagination-solution', clickable: true }"
							[autoplay]="{ delay: 5000, disableOnInteraction: false }"
						>
							<ng-template swiperSlide>
								<div class="solutionCard">
									<ng-container *ngTemplateOutlet="orgTpl"></ng-container>
								</div>
							</ng-template>
							<ng-template swiperSlide>
								<div class="solutionCard">
									<ng-container *ngTemplateOutlet="transportTpl"></ng-container>
								</div>
							</ng-template>
							<ng-template swiperSlide>
								<div class="solutionCard">
									<ng-container *ngTemplateOutlet="educationTpl"></ng-container>
								</div>
							</ng-template>
							<ng-template swiperSlide>
								<div class="solutionCard">
									<ng-container *ngTemplateOutlet="industryTpl"></ng-container>
								</div>
							</ng-template>
						</swiper>
					</div>

					<div class="solutionGridBox">
						<div class="solutionCard solutionGridCard">
							<ng-container *ngTemplateOutlet="orgTpl"></ng-container>
						</div>
						<div class="solutionCard solutionGridCard">
							<ng-container *ngTemplateOutlet="transportTpl"></ng-container>
						</div>
						<div class="solutionCard solutionGridCard">
							<ng-container *ngTemplateOutlet="educationTpl"></ng-container>
						</div>
						<div class="solutionCard solutionGridCard">
							<ng-container *ngTemplateOutlet="industryTpl"></ng-container>
						</div>
					</div>
				</div>
			</div> -->

			<!-- <div class="collabArea">
				<div class="collabBox">
					<div class="collabThumbs">
						<h2>合作對象</h2>

						<swiper
							[spaceBetween]="0"
							[slidesPerView]="2"
							[allowTouchMove]="false"
						>
							<ng-template swiperSlide>
								<span
									(click)="
										collabSwiper?.swiperRef.slideTo(0);
										accEnterpriseIndex = -1;
										accPoliticalIndex = -1
									"
									[ngClass]="{ activeSlide: collabSwiper?.swiperRef?.activeIndex === 0 }"
								>
									政府機構
								</span>
							</ng-template>
							<ng-template swiperSlide>
								<span
									(click)="
										collabSwiper.swiperRef.slideTo(1);
										accEnterpriseIndex = -1;
										accPoliticalIndex = -1
									"
									[ngClass]="{ activeSlide: collabSwiper?.swiperRef?.activeIndex === 1 }"
								>
									企業客戶
								</span>
							</ng-template>
						</swiper>
					</div>

					<div class="collabSwiperBox">
						<swiper
							#collabSwiper
							[thumbs]="{ swiper: thumbsSwiperRelation }"
							[slidesPerView]="1"
							[spaceBetween]="50"
							[speed]="200"
							[allowTouchMove]="false"
						>

							<ng-template swiperSlide>
								<div class="itemsCtn politicalBox">
									<div
										*ngFor="
											let governmentFrontItem of governmentFront;
											let governmentFrontIndex = index
										"
										class="item"
									>
										<img
											src="../../../assets/images/indexPage/relationship/{{
												governmentFrontItem.Type
											}}/{{
												governmentFrontItem.Type +
													'-' +
													governmentFrontItem.Sort +
													'-' +
													governmentFrontIndex
											}}.png"
											alt="{{ governmentFrontItem.Name }}"
											width="64"
										/>
										<p>{{ governmentFrontItem.Name }}</p>
									</div>
								</div>
								<div class="moreBox">
									<p-accordion
										[(activeIndex)]="accPoliticalIndex"
										[expandIcon]="'pi pi-angle-down'"
										[collapseIcon]="'pi pi-angle-up'"
									>
										<p-accordionTab
											[header]="
												accPoliticalIndex === -1 || accPoliticalIndex === null
													? '更多政府機構'
													: '收合'
											"
										>
											<div class="itemsCtn">
												<div
													*ngFor="
														let governmentBackItem of governmentBack;
														let governmentBackIndex = index
													"
													class="item"
												>
													<img
														src="../../../assets/images/indexPage/relationship/{{
															governmentBackItem.Type
														}}/{{
															governmentBackItem.Type +
																'-' +
																governmentBackItem.Sort +
																'-' +
																governmentBackIndex
														}}.png"
														alt="{{ governmentBackItem.Name }}"
														width="64"
													/>
													<p>{{ governmentBackItem.Name }}</p>
												</div>
												<div class="item item-not-hover"></div>
											</div>
										</p-accordionTab>
									</p-accordion>
								</div>
							</ng-template>

							<ng-template swiperSlide>
								<div class="itemsCtn enterpriseBox">
									<div
										*ngFor="
											let enterpriseFrontItem of enterpriseFront;
											let enterpriseFrontIndex = index
										"
										class="item"
									>
										<img
											src="../../../assets/images/indexPage/relationship/{{
												enterpriseFrontItem.Type
											}}/{{
												enterpriseFrontItem.Type +
													'-' +
													enterpriseFrontItem.Sort +
													'-' +
													enterpriseFrontIndex
											}}.png"
											alt="{{ enterpriseFrontItem.Name }}"
											width="64"
										/>
										<p>{{ enterpriseFrontItem.Name }}</p>
									</div>
								</div>
								<div class="moreBox">
									<p-accordion
										#politicalTab
										[(activeIndex)]="accEnterpriseIndex"
										[expandIcon]="'pi pi-angle-down'"
										[collapseIcon]="'pi pi-angle-up'"
									>
										<p-accordionTab
											[header]="
												accEnterpriseIndex === -1 || accEnterpriseIndex === null
													? '更多企業客戶'
													: '收合'
											"
										>
											<div class="itemsCtn">
												<div
													*ngFor="
														let enterpriseBackItem of enterpriseBack;
														let enterpriseBackIndex = index
													"
													class="item"
												>
													<img
														src="../../../assets/images/indexPage/relationship/{{
															enterpriseBackItem.Type
														}}/{{
															enterpriseBackItem.Type +
																'-' +
																enterpriseBackItem.Sort +
																'-' +
																enterpriseBackIndex
														}}.png"
														alt="{{ enterpriseBackItem.Name }}"
														width="64"
													/>
													<p>{{ enterpriseBackItem.Name }}</p>
												</div>
												<div class="item item-not-hover"></div>
												<div class="item item-not-hover"></div>
											</div>
										</p-accordionTab>
									</p-accordion>
								</div>
							</ng-template>
						</swiper>
					</div>
				</div>
			</div> -->
			<!-- <app-partnership></app-partnership> -->
		</div>
	</div>
</div>
<app-footer></app-footer>

<!-- ** 三安 金字塔 -->
<!-- <ng-template #pyramidTpl></ng-template> -->

<!-- ** 三安 文字描述 -->

<!-- <ng-template #nationTpl>
	<p>
		我們在治安科技與資訊安全的成功服務經驗上，觀察出數位科技在國家安全的重要性，2024年更投身加入國防產業發展協會資安成員；我們的目標是通過卓越的技術與專業服務，保護關鍵國家單位如國軍、交通、通訊等產業的關鍵系統，為國家提供全方位的安全保障，締造一個和平穩定的國家數位環境。
	</p>
</ng-template> -->

<!-- <ng-template #infoTpl>
	<p>
		我們以治安科技領域上的成功經驗為基礎，發展保護機關、企業或個人免受各種網絡攻擊、威脅勒索或資訊外洩等危機，透過預防、演練、模擬攻防等技術導入，強化產業重要核心資訊系統的使用、傳輸及儲存安全；我們目標為客戶打造最完善的安全防護機制，讓數位產業更加安全和可信。
	</p>
</ng-template> -->

<!-- <ng-template #orderTpl>
	<p>
		我們以犯罪防治、治安科技為發展基礎，提升社會在科技偵查、打擊犯罪的效率與效能，透過預防、偵蒐、偵辦、分析、判決、矯正等各項執法流程的數位轉型與導入，為機關與產業提供強有力的技術支持，創造更加和諧安全的社會環境。我們相信，通過數位科技的創新，能夠實現社會的全面進步，讓每個人都能在安全和諧的環境中生活和成長。
	</p>
</ng-template> -->

<!-- ** 解決方案 -->
<!-- <ng-template #orgTpl>
	<img
		src="/assets/images/indexPage/solution-military-unit.webp"
		alt=""
	/>
	<div class="strip">
		<span>國軍單位</span>
	</div>
</ng-template> -->

<!-- <ng-template #transportTpl>
	<img
		src="/assets/images/indexPage/solution-police-agency.webp"
		alt=""
	/>
	<div class="strip">
		<span>警察機關</span>
	</div>
</ng-template> -->

<!-- <ng-template #educationTpl>
	<img
		src="/assets/images/indexPage/solution-prosecutorial-and-judicial-authorities.webp"
		alt=""
	/>
	<div class="strip">
		<span>檢調司法</span>
	</div>
</ng-template> -->

<!-- <ng-template #industryTpl>
	<img
		src="/assets/images/indexPage/solution-transportation-and-logistics.webp"
		alt=""
	/>
	<div class="strip">
		<span>運輸物流</span>
	</div>
</ng-template> -->
